import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { getToken } from "../features/auth/slice/user.selector";
import { HttpService } from "../services/base.service";
import storageService from "./local-storage.utils";
import { restoreToken } from "../features/auth/slice/user.slice";

export const ScrollToTop = () => {
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const reduxToken = useSelector(getToken);

  useEffect(() => {
    window.scrollTo(0, 0);

    // Try Redux token first, then fall back to encrypted storage
    let token = reduxToken;
    if (!token) {
      const storedToken = storageService.getItem<string>('token');
      if (storedToken) {
        token = storedToken;
        // Restore token to Redux so route guards and components can access it
        dispatch(restoreToken(storedToken));
      }
    }

    if (token) {
      HttpService.setToken(token);
    }
  }, [pathname]);

  return null;
};
